module.exports = __webpack_public_path__ + "static/img/contant_4.098ce89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_8/contant_4.jpg
// module id = DB7X
// module chunks = 0